import React from "react";
import { SectionContainerBase } from "@reusejs/react";

export interface HeadingParagraphProps {
  heading?: string;
  headingStyles?: string;
  paragraphWrapperStyles?: string;
  paragraphs: any;
  paragraphStyle?: string;
  outerContainerStyles?: string;
  innerContainerStyles?: string;
}

export const HeadingParagraph = (props: HeadingParagraphProps) => {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles:
          props.outerContainerStyles ||
          "w-full px-4 mx-auto mt-2 md:mb-10 md:w-10/12 lg:w-7/12 xl:w-5/12",
        innerContainerStyles: props.innerContainerStyles || "relative",
      }}
    >
      <div
        className={
          props.headingStyles || "font-bold text-lg md:text-2xl pt-2 md:py-4"
        }
      >
        {props.heading}
      </div>
      <div className={props.paragraphWrapperStyles}>
        {props.paragraphs &&
          props.paragraphs.map((para: React.ReactNode) => {
            return (
              <p
                className={
                  props.paragraphStyle ||
                  "text-base font-normal text-gray-500 pt-2"
                }
              >
                {para}
              </p>
            );
          })}
      </div>
    </SectionContainerBase>
  );
};
